import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { delete_expense_category } from '../../Services/APIService';
import { Typography , Box} from '@mui/material';
import axios from 'axios';

export default function ExpenseCategoryDelete({ setExpenseCategoryName, ExpenseCategoryName, setExpenseCategoryId, ExpenseCategoryId, getAllExpense, setMessage, setOpen, setStatus, setColor, openExpenseDeleteDialog, setOpenExpenseDeleteDialog }) {
   
    const handleClose = () => {
        setOpenExpenseDeleteDialog(false);
    }

    const handleDeleteExpense = () => {
        if (ExpenseCategoryId !== '' && ExpenseCategoryId !== null) {
            const sendData = new FormData();
            sendData.append('expenseCategoryId', ExpenseCategoryId);
            axios({
                method: "POST",
                url: delete_expense_category,
                data: sendData
            }).then(res => {
                if (res.data.error) {
                    setMessage(res.data.message)
                    setOpen(true)
                    setStatus(false)
                    setColor(false)
                } else {
                    setOpen(true)
                    setMessage(res.data.message)
                    setStatus(true)
                    setColor(true)
                    handleClose();
                    getAllExpense();
                    setExpenseCategoryId('');
                    setExpenseCategoryName('');
                }
            }).catch(err => {
                console.log(err)
            });
        }
    }

    return (
        <div>
            <Dialog
                open={openExpenseDeleteDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"ARE YOU SURE THAT YOU WANNA DELETE THIS CATEGORY PERMANENTLY?"}
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Typography variant='subtitle1' fontWeight={600} color='#616e80'>Category Name: {ExpenseCategoryName}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant='outlined' color='primary'>CLOSE</Button>
                    <Button onClick={handleDeleteExpense} variant='outlined' autoFocus color='error'>
                        DELETE
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
